import React from 'react'
import RoleUserAccessMappingComponent from '../Components/RoleUserAccessMapping/RoleUserAccessMappingComponent'

const RoleUserAccessMappingPage = () => {
  return (
    <div><RoleUserAccessMappingComponent/></div>
  )
}

export default RoleUserAccessMappingPage